export default __webpack_public_path__ + "static/media/Pinterest.dfb63163.svg";